// extracted by mini-css-extract-plugin
export default {"tag":"Tag-tag-B2rUn Card-card-aoesq","label":"Tag-label-jmGXS"};